import { render, staticRenderFns } from "./TearmAdmin.vue?vue&type=template&id=7d688a76&scoped=true"
import script from "./TearmAdmin.vue?vue&type=script&lang=js"
export * from "./TearmAdmin.vue?vue&type=script&lang=js"
import style0 from "./TearmAdmin.vue?vue&type=style&index=0&id=7d688a76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d688a76",
  null
  
)

export default component.exports